module.exports = __webpack_public_path__ + "static/media/film-production-grid-3.b8e062bd.jpg";